import React from 'react';
import M3Chip from './M3Chip';

// One grave good with its linked artefacts and the page candidates it can
// claim (legacy Relations' per-good list pair).
export const figureName = (figure, id) => {
  if (!figure) return `Figure ${id}`;
  return `${figure.type} ${figure.identifier || figure.id}`;
};

export default function GoodRelationsCard({
  good,
  selected,
  onSelect,
  linkedIds,
  candidates,
  figuresById,
  onToggle
}) {
  return (
    <div className={`grave-related-good${selected ? ' is-selected' : ''}`}>
      <div className="grave-related-good-title" onClick={onSelect}>
        <span className="material-symbols-rounded">
          {selected ? 'radio_button_checked' : 'radio_button_unchecked'}
        </span>
        Good {good.identifier || good.id}
      </div>
      <div className="grave-related-section-label">Linked artefacts</div>
      <div className="grave-related-chips">
        {linkedIds.length === 0 && <span className="grave-related-none">None</span>}
        {linkedIds.map((fid) => (
          <M3Chip key={fid} variant="input" selected onClick={() => onToggle(good.id, fid)}>
            {figureName(figuresById.get(fid), fid)}
          </M3Chip>
        ))}
      </div>
      <div className="grave-related-section-label">On this page</div>
      <div className="grave-related-chips">
        {candidates.length === 0 && <span className="grave-related-none">No candidates</span>}
        {candidates.map((f) => (
          <M3Chip key={f.id} variant="suggestion" onClick={() => onToggle(good.id, f.id)}>
            {figureName(f, f.id)}
          </M3Chip>
        ))}
      </div>
    </div>
  );
}
